<template>
  <div id="scheduleDetail_singleResult">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="localDataProp && !localDataProp.isHasData"
    />
    <template v-else>
      <EVENTCOP_MODE_1
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_1' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_1>

      <EVENTCOP_MODE_3
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_3' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_3>

      <EVENTCOP_MODE_16
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_16' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_16>

      <EVENTCOP_MODE_17
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_17' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_17>

      <EVENTCOP_MODE_24
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_24' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
        :isCombatFlag="false"
      ></EVENTCOP_MODE_24>

      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// 适用： 单项成绩 【艺术体操|竞技体操|马术】
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_1 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_1.vue'
import EVENTCOP_MODE_3 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_3.vue'
import EVENTCOP_MODE_16 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_16.vue'
import EVENTCOP_MODE_17 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_17.vue'
import EVENTCOP_MODE_24 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_24.vue'

export default {
  name: 'scheduleDetail_singleResult',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    EVENTCOP_MODE_1,
    EVENTCOP_MODE_3,
    EVENTCOP_MODE_16,
    EVENTCOP_MODE_17,
    EVENTCOP_MODE_24,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    localDataProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
      }),
    },
  },
  watch: {
    localDataProp: {
      handler(newVal, oldVal) {
        console.debug('singleResult 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.eventCompModeDatas = JSON.parse(
            JSON.stringify(newVal.datas ? newVal.datas : {})
          )
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tabTypeKey: 'singleResult',
      eventCompModeDatas: null,
    }
  },
}
</script>

<style lang="scss" scoped>
#scheduleDetail_singleResult {
  padding-bottom: 2.083vw;
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
